import { StdResponse, request } from "@/global/config/request";
import { DeviceTotalTestConnectHistory } from "@/global/interface/device/device";
import { DeviceModelingDetail } from "@/global/interface/device/sensor";
import qs from "qs";


export function getDevices(projectId: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/project/${projectId}/devices`, {
        params: {
            ...params,
        }
    })
}

export function updateDeviceModelingDetail(id: number, data: DeviceModelingDetail, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/device-modelings/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function findTotaTestlTimeListByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/total-test/date`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function findTotalTestListByTimeAndProjectId(projectId: number, time: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/total-test`, {
        params: {
            time: time,
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function addTotalTestHistory(projectId: number, data: DeviceTotalTestConnectHistory[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/total-test`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteTotalTestHistory(projectId: number, time: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/projects/${projectId}/total-test`, {
        params: {
            time: time,
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}